import { useProposalStore } from "@/stores/risk/risk";
import { InsurerBenefits } from "@/stores/risk/types/types";
import { BenefitState } from "../types";

export function getBenefitsForQuote(insurerBenefits: InsurerBenefits | null): BenefitState {
    const proposalStore = useProposalStore();
    const coverDetails = proposalStore.proposal.risk.cover_details;
    return {
        hasBuildingsCovered: (coverDetails?.buildings_cover_amount ?? 0 > 0) ? true : false,
        hasContentsCovered: (coverDetails?.contents_cover_amount ?? 0 > 0) ? true : false,
        hasHomeEmergency: insurerBenefits?.home_emergency_response === "Yes" ? true : false,
        hasFireBrigadeCharges: insurerBenefits?.fire_brigade_charges === "Yes" ? true : false,
        hasLegalLiability: insurerBenefits?.legal_liability === "Yes" ? true : false,
        ipid: insurerBenefits?.ipid || ""
    };
}
